// extracted by mini-css-extract-plugin
export default {"spinner_layout":"spinner_loader_spinner_layout__ZaKjK"};